"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));

var _constant = require("../constant");

var _constant2 = require("./constant");

var _FAQ = require("./FAQ.proptypes");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var ContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "FAQ__ContainerWrapper",
  componentId: "sc-1eu87zn-0"
})(["display:grid;gap:", ";width:", ";@media screen and (min-width:", "){width:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.tiny;
}, function (_ref2) {
  var mobileSize = _ref2.mobileSize;
  return mobileSize.width;
}, _constant.BREAKPOINTS.LARGE_TABLET, function (_ref3) {
  var desktopSize = _ref3.desktopSize;
  return desktopSize.width;
});

var StyledCardItem = _styledComponents.default.div.withConfig({
  displayName: "FAQ__StyledCardItem",
  componentId: "sc-1eu87zn-1"
})(["padding:", ";background-color:", ";border-radius:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.small;
}, function (_ref5) {
  var open = _ref5.open,
      theme = _ref5.theme;
  return !open ? theme.colors.greyLighter : theme.colors.default;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius.normal;
});

var QuestionContent = _styledComponents.default.div.withConfig({
  displayName: "FAQ__QuestionContent",
  componentId: "sc-1eu87zn-2"
})(["display:flex;justify-content:space-between;"]);

var QuestionItem = _styledComponents.default.div.withConfig({
  displayName: "FAQ__QuestionItem",
  componentId: "sc-1eu87zn-3"
})([""]);

var IconItem = _styledComponents.default.div.withConfig({
  displayName: "FAQ__IconItem",
  componentId: "sc-1eu87zn-4"
})([""]);

var AnswerContent = _styledComponents.default.div.withConfig({
  displayName: "FAQ__AnswerContent",
  componentId: "sc-1eu87zn-5"
})(["margin-top:", ";display:", ";"], function (_ref7) {
  var theme = _ref7.theme,
      open = _ref7.open;
  return open ? theme.space.tiny : 0;
}, function (_ref8) {
  var open = _ref8.open;
  return open ? 'block' : 'none';
});

var renderText = function renderText(text, type, bold, color) {
  return /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: type,
    bold: bold,
    color: color
  }, text);
};

var renderAnswer = function renderAnswer(text, type, bold, color) {
  return /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: type,
    bold: bold,
    color: color
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};

var CardBody = function CardBody(props) {
  var data = props.data,
      onClick = props.onClick,
      open = props.open;
  var question = data.question,
      answer = data.answer;
  return /*#__PURE__*/_react.default.createElement(StyledCardItem, {
    open: open
  }, /*#__PURE__*/_react.default.createElement(QuestionContent, {
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(QuestionItem, null, renderText(question, _constant2.TOKENS.QUESTION.SIZE, _constant2.TOKENS.QUESTION.BOLD, _constant2.TOKENS.QUESTION.COLOR)), /*#__PURE__*/_react.default.createElement(IconItem, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: open ? _constant2.TOKENS.ICON.CONTENT.OPEN : _constant2.TOKENS.ICON.CONTENT.CLOSE,
    fontsize: _constant2.TOKENS.ICON.SIZE,
    color: _constant2.TOKENS.ICON.COLOR
  }))), /*#__PURE__*/_react.default.createElement(AnswerContent, {
    open: open
  }, renderAnswer(answer, _constant2.TOKENS.ANSWER.SIZE, _constant2.TOKENS.ANSWER.BOLD, _constant2.TOKENS.ANSWER.COLOR)));
};

var FAQ = function FAQ(props) {
  var theme = props.theme,
      customProperties = props.customProperties,
      data = props.data,
      openFirstItem = props.openFirstItem,
      title = props.title,
      titleType = props.titleType,
      titleMarginBottom = props.titleMarginBottom,
      size = props.size;

  var _useState = (0, _react.useState)({
    0: openFirstItem
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      openAnswer = _useState2[0],
      setOpenAnswer = _useState2[1];

  var defaultSize = {
    width: _constant2.TOKENS.DEFAULT_IMAGE_WIDTH
  };
  var dataExists = data && Object.keys(data).length !== 0;
  var isEmpty = data && Object.values(data).every(function (x) {
    return x === null || x === '';
  });
  return data && data !== null && dataExists && !isEmpty ? /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ContainerWrapper, (0, _extends2.default)({
    mobileSize: size.mobile || defaultSize,
    desktopSize: size.desktop || defaultSize
  }, customProperties), title && /*#__PURE__*/_react.default.createElement(_Title.default, {
    type: titleType,
    marginBottom: titleMarginBottom
  }, title), data.map(function (dataObj, i) {
    return /*#__PURE__*/_react.default.createElement(CardBody // eslint-disable-next-line react/no-array-index-key
    , {
      key: "d_".concat(i),
      data: dataObj,
      onClick: function onClick() {
        setOpenAnswer(_objectSpread(_objectSpread({}, openAnswer), (0, _defineProperty2.default)({}, i, !openAnswer[i])));
      },
      open: openAnswer[i]
    });
  }))) : null;
};

FAQ.propTypes = _FAQ.FAQPropTypes.PropTypes;
FAQ.defaultProps = _FAQ.FAQPropTypes.DefaultProps;
CardBody.propTypes = _FAQ.CardBodyPropTypes.PropTypes;
var _default = FAQ;
exports.default = _default;